import { createSignal, onMount } from "solid-js";

let clientMounted = false;

export default function createIsClient() {
  if (clientMounted) return () => true;

  const [isClient, setIsClient] = createSignal(false);

  onMount(() => {
    setIsClient(true);
    clientMounted = true;
  });

  return isClient;
}
